export const ShowAlert = ({ alerts = {}, tag = "", type = "danger" }) => {
    if (alerts && alerts[tag]) {
        return <div role="alert" className={`alert alert-${type}`} ><span>{alerts[tag]}</span></div>
    }
    return 
}